import { Outlet } from 'react-router-dom';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';
import { Suspense } from 'react';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { SuperAdminGuard } from '@repo/ui/features/superadmin';

export default function SuperAdminLayout() {
  return (
    <SuperAdminGuard>
      <DashboardLayout>
        <Suspense fallback={<DendromapLoader message="Chargement de l'espace superadmin..." />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </SuperAdminGuard>
  );
}
